import { useEffect } from 'react'

import { scheduleEffectsActions } from '../actions'
import { useActions, useAppSelector } from '../../../store/hooks'
import { authSelector } from '../../../store/slices/auth'
import { referencesSelector } from '../../../store/slices/references'
import { schedulePageSelector } from '../../../store/slices/schedulePage'

export function useScheduleEffects() {
    const isAuthorized = useAppSelector(authSelector.isAuthorized)
    const scheduleFilters = useAppSelector(schedulePageSelector.filters)
    const groupOptions = useAppSelector(referencesSelector.groupOptions)
    const teacherOptions = useAppSelector(referencesSelector.teacherOptions)
    const selectedGroupId = useAppSelector(schedulePageSelector.selectedGroupId)
    const selectedTeacherId = useAppSelector(schedulePageSelector.selectedTeacherId)

    const {
        scheduleLoad,
        referenceLoadPageData,
        setSelectedGroupId,
        setSelectedTeacherId,
    } = useActions(scheduleEffectsActions)

    useEffect(() => {
        if (!isAuthorized) return

        referenceLoadPageData()
    }, [isAuthorized, referenceLoadPageData])

    useEffect(() => {
        if (groupOptions.length > 0 && !selectedGroupId) {
            setSelectedGroupId(groupOptions[0].value)
        }
    }, [groupOptions, selectedGroupId, setSelectedGroupId])

    useEffect(() => {
        if (teacherOptions.length > 0 && !selectedTeacherId) {
            setSelectedTeacherId(teacherOptions[0].value)
        }
    }, [teacherOptions, selectedTeacherId, setSelectedTeacherId])

    useEffect(() => {
        if (!isAuthorized) return

        scheduleLoad(scheduleFilters)
    }, [isAuthorized, scheduleFilters, scheduleLoad])
}
